var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cabinet-content-inner"},[_c('div',{staticClass:"cabinet-notice-big subscribe-text-success"},[_c('div',{staticClass:"icon"},[_c('SuccessIcon')],1),_c('div',{staticClass:"text"},[_vm._v("Подписка на письмо успешно оформлена!")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }